// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import styles from "./contractDetails.module.css";
import { v4 as uuid } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { useDrop } from "react-dnd";
import { useEffect, useMemo, useState } from "react";
import LeftContract from "./_components/LeftContract";
import { RightContract } from "./_components/RightContract";
import { PDFDocument, rgb } from "pdf-lib";
import { isUserRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import { DocumentScanner, ManageAccounts } from "@mui/icons-material";
import { DetailsForm } from "./_components/DetailsForm";
import { useDispatch } from "react-redux";
import {
  addNewContractAction,
  addSignatureToContractAction,
  attachFileToContract,
  editContractAction,
  updateContractStatusAction,
} from "../../store/actions/contract/contract";
import {
  convertBackendToFrontend,
  convertFrontendToBackend,
} from "../../utils/methods/other/otherUtils";
import { alertDialogAciton } from "../../store/actions/auth";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { CONTRACT_STATUS } from "../../utils/constants/nmaes";
import * as Yup from "yup";
import { useFormik } from "formik";
import { isURL } from "../../utils/methods/other/otherUtils";
import {
  ColorlibStepIconRoot,
  StepperWrapper,
} from "../../components/Custom/stepper/stepper";
import { ViewDetailsForm } from "./_components/ViewDetailsForm";
import AdditionalDocument from "./_components/AdditionalDocuemnt";

export const ContractDetails = () => {
  const loadingInitStates = useMemo(() => {
    return {
      addNewLoading: false,
      approveLoading: false,
      discardLoading: false,
      sendBackLoading: false,
    };
  }, []);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const isEdit = state?.data?._id ?? false;
  const [readOnly, setReadOnly] = useState(false);
  const [file, setFile] = useState(null);
  const [showError, setShowError] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [currPage, setCurrPage] = useState(1);
  const [fields, setFields] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [conData, setConData] = useState({});
  const [showDrag, setShowDrag] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [loading, setLoaidng] = useState(loadingInitStates);
  const [showRequiredDocError, setShowRequiredDocError] = useState(false);
  const navigate = useNavigate();

  const initialValues = {
    contractName: "",
    contractDescription: "",
    requiredDocuments: [],
    userRoles: [],
    users: [],
    isAttachToEvent: false,
    eventId: null,
    attachments: [],
    isAutoVerify: false,
  };

  const validationSchema = Yup.object().shape({
    contractName: Yup.string()
      .trim()
      .required("Contract Name is required.")
      .max(200, "A contract name should at most 200 chatachers"),
    contractDescription: Yup.string()
      .trim()
      .max(1500, "A contract name should at most 1500 chatachers")
      .required("Contractor Description is required."),
    requiredDocuments: Yup.array(),
    userRoles: Yup.array(),
    users: Yup.array(),
    isAttachToEvent: Yup.boolean(),
    eventId: Yup.object().when("isAttachToEvent", {
      is: true,
      then: (schema) => schema.required("Please select the attached event"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
    attachments: Yup.array().of(
      Yup.mixed().test("fileType", "Unsupported File Format", (value) => {
        if (!value) return true;
        return value instanceof File || isURL(value?.url);
      }),
    ),
    userRolesOrUsers: Yup.mixed().test(
      "userRolesOrUsers-required",
      "Either users or user roles must be selected.",
      function (_, context) {
        const { users, userRoles } = context.parent;
        const hasUsers = Array.isArray(users) && users.length > 0;
        const hasUserRoles = Array.isArray(userRoles) && userRoles.length > 0;
        return hasUsers || hasUserRoles;
      },
    ),
    isAutoVerify: Yup.boolean(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      // setCurrentStep((prev) => prev + 1);
      setConData(values);
      submitContractHandler();
    },
  });

  const {
    values,
    setValues,
    setFieldValue,
    handleBlur,
    touched,
    errors,
    handleChange,
    submitForm,
  } = formik;

  useEffect(() => {
    const existingData = {
      ...state?.data,
      recipients: [state?.data?.receipents],
    };
    if (!existingData?._id) return;
    else {
      setValues({
        contractName: existingData?.contractName,
        contractDescription: existingData?.description,
        users: existingData?.recipients?.map((item) => ({
          ...item,
          fullName: item?.name,
        })),
        isAttachToEvent: !!existingData?.eventId,
        requiredDocuments: existingData?.requiredDocuments,
        eventId: existingData?.eventId
          ? {
              _id: existingData?.eventId,
              eventName: existingData?.eventName,
              eventStart: existingData?.eventStart,
              eventEnd: existingData?.eventEnd,
              profileImage: existingData?.profileImage,
            }
          : null,
        attachments: existingData?.attachment?.map((item) => ({
          ...item,
          name: item?.attachmentName,
        })),
      });
    }
  }, [state, setValues]);

  function fileChangeHandler(e) {
    const file = e.target.files?.[0];
    if (file?.name?.split(".")?.pop() !== "pdf") {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: "The contract should be of pdf type",
        }),
      );
      return;
    }
    if (file) setFile(file);
  }

  const [, drop] = useDrop(() => {
    return {
      accept: "TOOL",
      drop: ({ item }, monitor) => {
        const offset = monitor.getClientOffset();
        const dropTarget = document.getElementById("drop-area");

        if (!offset || !dropTarget) return;

        const dropRect = dropTarget.getBoundingClientRect();

        const x = offset.x - dropRect.left;
        const y = offset.y - dropRect.top;

        setFields((prev) => [
          ...prev,
          {
            id: uuid(),
            _id: item?._id,
            type: item.type,
            value: item?.text || item?.url,
            x,
            y,
            page: currPage,
            width: 120,
            height: 40,
          },
        ]);
      },
    };
  }, [currPage]);

  async function handleDownload() {
    if (!file) return;

    let arrayBuffer;
    if (typeof file == "string") {
      arrayBuffer = await fetch(file).then((res) => res.arrayBuffer());
    } else {
      arrayBuffer = await file.arrayBuffer();
    }
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const pages = pdfDoc.getPages();

    for (const field of fields) {
      const page = pages[(field.page ?? 1) - 1];
      const { width, height } = page.getSize();
      const adjustedY = height - field.y - field.height;

      if (field.type === "Signature" && field.value) {
        try {
          const imageBytes = await fetch(field.value).then((res) =>
            res.arrayBuffer(),
          );
          const image = await pdfDoc.embedPng(imageBytes);
          page.drawImage(image, {
            x: field.x,
            y: adjustedY,
            width: field.width,
            height: field.height,
          });
        } catch (err) {
          console.error("Failed to embed signature image:", err);
        }
      } else {
        page.drawText(field?.value ?? "", {
          x: field.x,
          y: adjustedY + 10,
          size: 12,
          color: rgb(0, 0, 0),
          maxWidth: field.width,
        });
      }
    }

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "final.pdf";
    a.click();
    URL.revokeObjectURL(url);
  }

  function submitContractHandler() {
    // console.log(">?>? values", values);
    // return;
    if (!file) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
      return;
    }

    setLoaidng((prev) => ({ ...prev, addNewLoading: true }));

    // add contract function
    const formData = new FormData();
    formData.append(
      "recipients",
      JSON.stringify([
        ...(values?.userRoles?.map((item) => ({ userRole: item })) || []),
        ...(values?.users?.map((item) => ({
          ...item,
          userId: item?._id,
          name: item?.fullName,
        })) || []),
      ]),
    );
    formData.append("date", dayjs()?.format("YYYY-MM-DD"));
    formData.append("files", file);
    formData.append(
      "requiredDocuments",
      JSON.stringify(
        values?.requiredDocuments?.map((item) => ({ name: item })),
      ),
    );
    Object.entries(values)?.forEach(([key, value]) => {
      if (value) {
        if (
          key == "userRoles" ||
          key == "users" ||
          key == "requiredDocuments"
        ) {} else if (key === "eventId") {
          formData.append("eventId", value?._id);
          formData.append("eventName", value?.eventName);
          formData.append("eventStart", value?.eventStart);
          formData.append("eventEnd", value?.eventEnd);
        } else {
          if (key == "contractDescription") {
            formData.append("description", value);
          } else if (key !== "attachments") {
            formData.append(key, value);
          }
        }
      }
    });
    function afterAddEditSuccess(res) {
      // after success add signatures and add attachments simultaneously
      // NOTE: add signatures
      function successAlert() {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Success",
            message: res?.data?.message || "Contract Sent Successfully.",
          }),
        );
        setLoaidng((prev) => ({ ...prev, addNewLoading: false }));
        navigate(-1);
      }
      if (fields?.length === 0) {
        successAlert();
      }

      const params = {
        id: res?.data?.data?.[0]?._id,
      };
      dispatch(
        addSignatureToContractAction({
          payload: {
            data: { signatureData: convertFrontendToBackend(fields) },
            params,
          },
          successCallback: () => {
            successAlert();
          },
        }),
      );
      // NOTE: add attachments if any
      const attachmentData = new FormData();
      values?.attachments?.forEach((item, i) => {
        attachmentData?.append("files", item);
      });
      dispatch(
        attachFileToContract({
          payload: {
            data: attachmentData,
            params,
          },
        }),
      );
    }
    if (!state?.data?._id) {
      dispatch(
        addNewContractAction({
          payload: {
            data: formData,
          },
          successCallback: (res) => {
            afterAddEditSuccess(res);
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: msg || "Fail to send contract.",
              }),
            );
            setLoaidng((prev) => ({ ...prev, addNewLoading: false }));
          },
        }),
      );
    } else {
      dispatch(
        editContractAction({
          payload: {
            data: formData,
            params: {
              id: state?.data?._id,
            },
          },
          successCallback: (res) => {
            afterAddEditSuccess(res);
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: msg || "Fail to edit contract.",
              }),
            );
            setLoaidng((prev) => ({ ...prev, addNewLoading: false }));
          },
        }),
      );
    }
  }

  function startLoadingForCase({ status, loadingStatus }) {
    switch (status) {
      case CONTRACT_STATUS.SENT:
        setLoaidng((prev) => ({
          ...prev,
          sendBackLoading: loadingStatus,
        }));
        return;
      case CONTRACT_STATUS.REVIEW:
        setLoaidng((prev) => ({
          ...prev,
          addNewLoading: loadingStatus,
        }));
        return;
      case CONTRACT_STATUS.VERIFIED:
        setLoaidng((prev) => ({ ...prev, approveLoading: loadingStatus }));
        return;
      case CONTRACT_STATUS.DISCARDED:
        setLoaidng((prev) => ({ ...prev, discardLoading: loadingStatus }));
        return;
      default:
        return;
    }
  }

  function sendForApprovalHandler(status) {
    if (values?.requiredDocuments?.find((item) => !item?.url)) {
      setShowRequiredDocError(true);
      return;
    }
    startLoadingForCase({ status, loadingStatus: true });
    const params = {
      id: state?.data?._id,
    };

    dispatch(
      updateContractStatusAction({
        payload: {
          params,
          data: {
            status,
          },
        },
        successCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: msg || "Contract sent for approval",
            }),
          );
          navigate(-1);
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Fail to sent contract for approval",
            }),
          );
        },
      }),
    );
  }

  function sendForApprovalHandlerv2(status) {
    if (values?.requiredDocuments?.find((item) => !item?.url)) {
      setShowRequiredDocError(true);
      return;
    }
    startLoadingForCase({ status, loadingStatus: true });
    const params = {
      id: state?.data?._id,
    };

    dispatch(
      addSignatureToContractAction({
        payload: {
          data: { signatureData: convertFrontendToBackend(fields) },
          params,
        },
        successCallback: () => {
          dispatch(
            updateContractStatusAction({
              payload: {
                params,
                data: {
                  status,
                },
              },
              successCallback: (msg) => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: msg || "Contract sent for approval",
                  }),
                );
                navigate(-1);
              },
              failureCallback: (msg) => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Error",
                    message: msg || "Fail to sent contract for approval",
                  }),
                );
              },
            }),
          );
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Failed to send contract for review",
            }),
          );
        },
      }),
    );
  }

  useEffect(() => {
    if (!state?.data?._id) return;
    else {
      setFile(state?.data?.contractPdf?.url);
      setFields(
        convertBackendToFrontend([
          ...(state?.data?.textData || []),
          ...(state?.data?.signatureData || []),
        ]),
      );
      setReadOnly(state?.data?.readOnly);
    }
  }, [state?.data]);

  useEffect(() => {
    switch (state?.data?.status) {
      case "sent":
        if (isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN)) {
          setShowDrag(false);
        } else {
          setShowDrag(true);
        }
        return;
      case "review":
        setShowDrag(false);
        return;
      case "verified":
        setShowDrag(false);
        return;
      case "discarded":
        setShowDrag(false);
        return;

      default:
        setShowDrag(false);
    }
  }, [state]);

  useEffect(() => {
    if (!showRequiredDocError) return;
    const timeout = setTimeout(() => {
      setShowRequiredDocError(false);
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [showRequiredDocError]);

  if (state?.data?.status) {
    return (
      <Box>
        {/* <Box className={styles["title-container"]}> */}
        {/*   <Typography variant={isSmallScreen ? "h3" : "h1"}> */}
        {/*     {state?.data?.contractName ?? "Create new contract"} */}
        {/*   </Typography> */}
        {/* </Box> */}

        {/* NOTE: contract details container */}
        <ViewDetailsForm
          setCurrentStep={setCurrentStep}
          setConData={setConData}
          existingData={state?.data || null}
          readOnly={readOnly}
          status={state?.data?.status}
          values={values}
          setValues={setValues}
          errors={errors}
          setFieldValue={setFieldValue}
          submitForm={submitForm}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          handleContractUpload={fileChangeHandler}
          file={file}
          clearFile={() => setFile(null)}
          showErrors={showError}
        />

        {/* NOTE: sub parent conainer  */}
        <Box className={styles["sub-parent-container"]}>
          <Grid container className={styles["dnd-container"]} gap={2}>
            {showDrag && (
              <Grid item xs={12} lg={4} className={styles["left"]}>
                <LeftContract currPage={currPage} setFields={setFields} />
              </Grid>
            )}
            <Grid
              item
              // xs={12}
              // sm={8.5}
              // id="drop-area"
              // ref={drop}
              className={styles["right"]}
            >
              <RightContract
                drop={drop}
                file={file}
                setTotalPage={setTotalPage}
                currPage={currPage}
                setCurrPage={setCurrPage}
                setFields={setFields}
                fields={fields}
                totalPage={totalPage}
                fileChangeHandler={fileChangeHandler}
                handleDownloadContract={handleDownload}
                readOnly={!showDrag}
              />
            </Grid>
          </Grid>
          <AdditionalDocument
            existingData={state?.data || null}
            readOnly={readOnly}
            status={state?.data?.status}
            values={values}
            setFieldValue={setFieldValue}
          />

          {showError && !file && (
            <Typography
              className="error"
              sx={{
                textAlign: "center",
                border: "none !important",
              }}
            >
              Please add the contract before sending
            </Typography>
          )}

          {showRequiredDocError && (
            <Typography
              className="error"
              sx={{
                textAlign: "center",
                border: "none !important",
              }}
            >
              Please add the required documents before sending it for review
            </Typography>
          )}

          <Box
            className="bottomButton"
            sx={{
              marginY: "2rem",
              justifyContent: isSmallScreen ? "flex-start" : "center",
            }}
          >
            <Button onClick={() => navigate(-1)} className="btnBlack">
              Back
            </Button>
            {state?.data?.type == "new" ? (
              state?.data?.status == "sent" &&
              isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN) ? null : (
                <Button
                  className="btnPink"
                  sx={{
                    cursor: loading?.addNewLoading ? "not-allowed" : "pointer",
                  }}
                  onClick={() => {
                    if (loading?.addNewLoading) return;
                    if (state?.data?.type == "new") {
                      sendForApprovalHandlerv2(CONTRACT_STATUS.REVIEW);
                    } else {
                      submitContractHandler();
                    }
                  }}
                >
                  {loading?.addNewLoading ? (
                    <CircularProgress sx={{ fontSize: "1.5rem" }} />
                  ) : state?.data?.type == "new" ? (
                    "Send For Review"
                  ) : state?.data?._id ? (
                    "Edit Contract"
                  ) : (
                    "Send"
                  )}
                </Button>
              )
            ) : (
              state?.data?.status == "review" &&
              isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN) && (
                <>
                  <Button
                    className="btnPink"
                    sx={{
                      cursor: loading?.approveLoading
                        ? "not-allowed"
                        : "pointer",
                    }}
                    onClick={() => {
                      if (loading?.approveLoading) return;
                      sendForApprovalHandler(CONTRACT_STATUS.VERIFIED);
                    }}
                  >
                    {loading?.approveLoading ? (
                      <CircularProgress sx={{ fontSize: "1.5rem" }} />
                    ) : (
                      "Approve Contract"
                    )}
                  </Button>

                  <Button
                    className="btnPink"
                    sx={{
                      cursor: loading?.discardLoading
                        ? "not-allowed"
                        : "pointer",
                    }}
                    onClick={() => {
                      if (loading?.discardLoading) return;
                      sendForApprovalHandler(CONTRACT_STATUS.DISCARDED);
                    }}
                  >
                    {loading?.discardLoading ? (
                      <CircularProgress sx={{ fontSize: "1.5rem" }} />
                    ) : (
                      "Discard Contract"
                    )}
                  </Button>
                </>
              )
            )}
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Box className={styles["title-container"]}>
        <Typography variant={isSmallScreen ? "h3" : "h1"}>
          {state?.data?.contractName ?? "Create new contract"}
        </Typography>
      </Box>

      <DetailsForm
        setCurrentStep={setCurrentStep}
        setConData={setConData}
        existingData={state?.data || null}
        readOnly={readOnly}
        status={state?.data?.status}
        values={values}
        setValues={setValues}
        errors={errors}
        setFieldValue={setFieldValue}
        submitForm={submitForm}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched}
        handleContractUpload={fileChangeHandler}
        file={file}
        clearFile={() => setFile(null)}
        showErrors={showError}
        loading={loading?.addNewLoading}
      />
    </Box>
  );
};

ContractDetails.propTypes = {
  readOnly: PropTypes.bool,
};